import { VSelectItem } from "@/core/interfaces/v-select.interface";
import { Clinic, MISClinic } from "@/core/references/clinics/clinic.interface";
import { AxiosInstance } from "axios";

export class ClinicsReference {
  #list: MISClinic[] = [];

  constructor(private http: AxiosInstance) {}

  async getList(name = ""): Promise<MISClinic[]> {
    try {
      const { data } = await this.http.get(`/v1/clinics`, {
        params: { name },
      });
      this.#list = data?.data || [];

      return this.#list;
    } catch (e) {
      console.log(e.response);
    }

    return [];
  }

  async getByCode(id: string): Promise<Clinic | null> {
    try {
      const { data } = await this.http.get(`/v1/references/clinics/${id}`);
      return data?.data;
    } catch (e) {
      console.log(e.response);
    }

    return null;
  }

  getSelectItems(): VSelectItem[] {
    return this.#list.map((item) => ({
      text: item.mis_organization_name,
      value: item.mis_organization_id,
    }));
  }
}
